// extracted by mini-css-extract-plugin
module.exports = {"list":"HorizontalColumns_list__1Bfb6"};